import React, { useEffect, useState } from "react";
import Header from "../../partials/Header";
import Sidebar from "../../partials/Sidebar";
import BackIcon from "../../../assets/icons/icon-back.svg";
import UploadIcon from "../../../images/icon-upload.png";
import { useSelector } from "react-redux";
import { notification } from "antd";
import styles from "./style.module.css";
import { Link, useNavigate } from "react-router-dom";
const Add = () => {
  const isAuthenticated = useSelector((state) => state.user);
  const url = process.env.REACT_APP_APP_BACK_URL;
  const [credentials, setCredentials] = useState({
    name: "",
    address: "",
    url: "",
    door_relay: "",
    ip_address: "",
    stream_url: "",
    slug: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [hasDoor, setHasDoor] = useState("no");
  const [departmentsEnabled, setDepartmentsEnabled] = useState(false);

  const [profileImage, setProfileImg] = useState("");
  const [error, setError] = useState(null);
  const [seletectedFile, setSelectedFile] = useState("");

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png"];
      if (allowedTypes.includes(file.type)) {
        setSelectedFile(file);
        setError(null);
        // Create a FileReader
        const reader = new FileReader();
        // Add a progress event listener to the FileReader

        reader.onload = (e) => {
          const dataURL = e.target.result; // This is the data URL of the selected image
          setProfileImg(dataURL); // Set the data URL as the profileImg
        };
        // Read the file (you can also add other event listeners like 'onload')
        reader.readAsDataURL(file);
      } else {
        //setFile(null);
        setError("Invalid file type. Please select an image file.");
        // setTimeout(() => {
        //   setError(null);
        // }, 3000);
      }
    }
  };

  const handleInput = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const formSubmit = async (e) => {
    e.preventDefault();
    // let headers = new Headers();
    // headers.append("Content-Type", "application/json");
    // headers.append("Access-Control-Allow-Origin", "*");
    // headers.append("Access-Control-Allow-Credentials", "true");

    const formData = new FormData();

    formData.append("name", credentials.name);
    formData.append("address", credentials.address);
    formData.append("door_relay", credentials.door_relay);
    formData.append("url", credentials.url);
    formData.append("ip_address", credentials.ip_address);
    formData.append("has_door", hasDoor);
    formData.append("departments_enabled", departmentsEnabled ? "yes" : "no");
    formData.append("slug", credentials.slug);
    formData.append("stream_url", credentials.stream_url);

    if (seletectedFile) {
      formData.append("file", seletectedFile);
    }
    setIsLoading(true);
    const response = await fetch(`${url}/api/sites/createSite`, {
      // mode: "cors",
      method: "POST",
      // headers: headers,
      // body: JSON.stringify({
      //   name: credentials.name,
      //   address: credentials.address,
      //   door_relay: credentials.door_relay,
      //   url: credentials.url,
      //   ip_address: credentials.ip_address,
      //   has_door: hasDoor,
      //   slug: credentials.slug,
      // }),
      body: formData,
    });
    setIsLoading(false);
    const json = await response.json();
    console.log(json);
    if (json.success) {
      setCredentials({
        name: "",
        address: "",
        url: "",
        door_relay: "",
        ip_address: "",
        slug: "",
      });
      setHasDoor("no");
      setIsChecked(false);
      setDepartmentsEnabled(false);
      notification.success({
        message: "Success",
        description: "Site Created Successfully",
        duration: 3,
      });
    } else {
      setIsLoading(false);
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };
  const handleCheckboxChange = (event) => {
    const newCheckedState = event.target.checked;
    setIsChecked(newCheckedState);
    setHasDoor(newCheckedState ? "yes" : "no");
  };
  const [isActive, setIsActive] = useState(false);
  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row add-new-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap user-back-wrap">
                <Link to="/site/list">
                  <div className="back-icon">
                    <img src={BackIcon} alt="" />
                  </div>
                </Link>
                <div className="user-back-det">
                  <h3>create site</h3>
                  <p>List of all the sites registered in the system</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 text-end"></div>
          </div>
        </div>
        {/* row */}
        <form onSubmit={formSubmit}>
          <div className="form-box card-box">
            <div className="row">
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Site Name</h4>
                      <p>Enter the name of the site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="sitec"
                        placeholder="Site Name"
                        name="name"
                        value={credentials.name}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Site Slug</h4>
                      <p>Enter the slug of the site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="sitec"
                        placeholder="Site Slug"
                        name="slug"
                        value={credentials.slug}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Site Url</h4>
                      <p>Enter the url of the site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        placeholder="Site Url"
                        name="url"
                        required
                        value={credentials.url}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Site Ip Address</h4>
                      <p>Enter the Ip Address of the site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        placeholder="Ip Address"
                        name="ip_address"
                        required
                        value={credentials.ip_address}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>RTSP Stream</h4>
                      <p>Enter the url of rtsp stream</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        placeholder="rtsp://12.33.322..."
                        name="stream_url"
                        value={credentials.stream_url}
                        onChange={handleInput}
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>
                        <input
                          type="checkbox"
                          className="form-check-input ml-2"
                          name="has_door"
                          style={{ marginRight: "2px" }}
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                        Has Door ?
                      </h4>
                      <p>Check the checkbox if site has the door</p>
                    </div>
                  </div>

                  {isChecked && (
                    <div className="col-xl-7 col-lg-7">
                      <div className="inpt-wrap">
                        <input
                          type="text"
                          placeholder="Enter door relay"
                          name="door_relay"
                          required
                          value={credentials.door_relay}
                          onChange={handleInput}
                        />
                      </div>
                    </div>
                  )}
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>
                        <input
                          type="checkbox"
                          className="form-check-input ml-2"
                          name="departments_enabled"
                          style={{ marginRight: "2px" }}
                          checked={departmentsEnabled}
                          onChange={(event) => setDepartmentsEnabled(event.target.checked)}
                        />
                        Departments
                      </h4>
                      <p>Site admin will see Departments in the sidebar</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Site Logo</h4>
                      <p>Select the logo for the site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div>
                      <div className=" row ">
                        <div className="col-lg-2 ">
                          <img
                            src={profileImage}
                            style={{ width: "40px", height: "40px" }}
                          />
                        </div>
                        <div className="inpt-wrap col-lg-10 ">
                          <input
                            type="file"
                            className="form-control"
                            name="file"
                            onChange={handleFileSelect}
                            // required
                          />
                        </div>
                      </div>
                      {error && (
                        <div
                          style={{
                            fontSize: "12px",
                            color: "red",
                            fontStyle: "italic",
                          }}
                        >
                          {error}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Site Address</h4>
                      <p>Enter complete address of the site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <textarea
                        name="address"
                        placeholder="Enter Address"
                        id=""
                        cols="30"
                        rows="7"
                        value={credentials.address}
                        onChange={handleInput}
                      >
                        2405 Wesbrook Mall, Vancouver, BC V6T 1Z4, Canada
                      </textarea>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-12 text-end">
                <div className="form-btn-wrap mb-5 pb-5">
                  <button
                    type="submit"
                    className="btn btn-prim w-auto ms-5"
                    disabled={isLoading}
                  >
                    {isLoading ? "Creating..." : "create site"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default Add;
